import { completeOnboardingHint } from '../api/onboardingHints';

const STORAGE_KEY = 'smetter_hints';

type HintRecord = { shown: number; permanent: boolean; completedAt?: number };
type HintsState = Record<string, HintRecord>;

const load = (): HintsState => {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '{}');
    } catch {
        return {};
    }
};

const save = (state: HintsState): void => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
};

export const hintStorage = {
    getHint: (id: string): HintRecord => load()[id] ?? { shown: 0, permanent: false },

    markShown: (id: string): void => {
        const state = load();
        const cur = hintStorage.getHint(id);
        state[id] = { ...cur, shown: cur.shown + 1 };
        save(state);
    },

    markPermanent: (id: string): void => {
        const state = load();
        const cur = hintStorage.getHint(id);
        state[id] = { shown: cur.shown, permanent: true, completedAt: Date.now() };
        save(state);
    },

    markCompleted: (id: string): void => {
        hintStorage.markPermanent(id);
        void completeOnboardingHint(id).catch((error) => {
            console.warn('Failed to sync completed onboarding hint', error);
        });
    },

    mergeCompletedHints: (ids: string[]): void => {
        const state = load();
        const completedAt = Date.now();

        ids.forEach((id) => {
            const cur = state[id] ?? { shown: 0, permanent: false };
            state[id] = {
                shown: cur.shown,
                permanent: true,
                completedAt: cur.completedAt ?? completedAt,
            };
        });

        save(state);
    },
};
